require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-video-lgbti-y-diversidades-sexuales-ancestrales-indigenas.json") })
        }
      }, "path---es-mx-update-video-lgbti-y-diversidades-sexuales-ancestrales-indigenas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-video-lgbti-y-diversidades-sexuales-ancestrales-indigenas!./.cache/json/es-mx-update-video-lgbti-y-diversidades-sexuales-ancestrales-indigenas.json
// module id = 939
// module chunks = 231608221292675